import {
  WebshopCategoryDetail,
  WebshopCategoryIdAndName,
  WebshopProduct,
} from '@cldsystems/ws-api-client';
import { useAppContext } from '@/providers/app-provider/app-provider';
import { CategoryTree } from '@/types/category/category-get-tree';
import { List } from '@/types/common';
import { Filter } from '@/types/product-filter';

type ProductsPageContext = {
  categoryTrees: CategoryTree[];
  products: List<WebshopProduct>;
  category: WebshopCategoryDetail;
  subCategories: WebshopCategoryIdAndName[];
  /** Pre-sorted facet filters from the server (build time for static pages). */
  categoryFilters?: Filter[];
};

const useProductsPageContext = (): ProductsPageContext => {
  const context = useAppContext<ProductsPageContext>();
  if (!context.categoryTrees) {
    throw new Error('useCategoryTree must be passed to <Page/> context');
  }
  if (!context.products) {
    throw new Error('products must be passed to <Page/> context');
  }
  if (!context.category) {
    throw new Error('category must be passed to <Page/> context');
  }
  if (!context.subCategories) {
    throw new Error('subcategories must be passed to <Page/> context');
  }
  return context;
};

export default useProductsPageContext;
